// @flow
import React, { Component } from 'react';
import { Jumbotron } from 'reactstrap';
import uniqueId from 'lodash/uniqueId';
import isEmpty from 'lodash/isEmpty';

import config from '../../../../config';
import ToggleDescription from './../../ToggleDescription';

import JumbotronImageSlider from '../../../../components/JumbotronImageSlider';
import EditButton from '../../../../components/Buttons/EditButton';
import withEditPermission from '../../../../HOCs/withEditPermission';

import type { placeJumbotron } from '../../../../types/place';

type Props = {
  ...placeJumbotron,
  isSuperUser: () => boolean,
  toggleEditing: () => void,
};

class PlaceJumbotron extends Component<Props> {
  render() {
    const {
      name,
      primary_image,
      tagline,
      altitude,
      text,
      isSuperUser,
      toggleEditing,
      coverImages,
      banner_images,
    } = this.props;

    const images = isEmpty(coverImages)
      ? [`${config.RESOURCE_URL}/${banner_images.medium}`]
      : coverImages.map(img => `${config.RESOURCE_URL}/${img.primary_image}`);
    const largeImageURL = `${config.RESOURCE_URL}/${primary_image}`;

    return (
      <div className="no-gutters" id="overview">
        <div className="col-12">
          <Jumbotron className="place-jumbotorn">
            <div className="img-wrap">
              <JumbotronImageSlider images={images} primaryImageUrl={largeImageURL} />
            </div>
            <div className="row no-gutters place-jumbotorn-caption">
              <div className="col-12">
                <h1>
                  {name.toUpperCase()} <small>{tagline && ` - ${tagline}`}</small>
                  {isSuperUser ? <EditButton onEditPress={toggleEditing} /> : null}
                </h1>
                <ul className="place-data-list">
                  <li>
                    {altitude &&
                      altitude.meters &&
                      `${Number(altitude.meters).toLocaleString()} meters`}
                  </li>
                </ul>
                {text && (
                  <ToggleDescription
                    data={text.split('\n\n').map(t => (
                      <p key={uniqueId('des')}>{t}</p>
                    ))}
                    defaultHeight={90}
                    moreLessText="Read"
                  />
                )}
              </div>
            </div>
          </Jumbotron>
        </div>
      </div>
    );
  }
}

export default withEditPermission(PlaceJumbotron);



// WEBPACK FOOTER //
// ./src/screens/Places/Viewers/PlacesJumbotron/PlacesJumbotron.jsx